module.exports = __webpack_public_path__ + "img/3.6_Russian_road_sign.37c2c6e0.svg";